import {CopilotIcon, PaperAirplaneIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

import {useAskCopilotPrompts} from './use-ask-copilot-prompts'

/**
 * Icon-only "Ask Copilot" entry point rendered in the README header tab bar. Clicking the trigger
 * opens a menu of icebreaker prompts; selecting one opens Copilot Chat seeded with that prompt.
 */
export function AskCopilotReadmeMenu() {
  const {prompts, onPromptClick} = useAskCopilotPrompts({location: 'readme-header', readme: true})

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton
          icon={CopilotIcon}
          aria-label="Ask Copilot about this repository"
          variant="invisible"
          size="small"
        />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay width="medium">
        <ActionList>
          {prompts.map(prompt => (
            <ActionList.Item key={prompt.label} onSelect={() => onPromptClick(prompt)}>
              <ActionList.LeadingVisual>
                <PaperAirplaneIcon />
              </ActionList.LeadingVisual>
              {prompt.label}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
